import React from 'react';
import Sidebar from './Sidebar';
import Main from './Main';
import { useLocation } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import '../App.css';

const Layout = ({children}) => {
    const location = useLocation();
    const isHome = location.pathname === '/home';

    return (
        <>
            <Sidebar />

            {isHome ? (
                <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    style={{ position: 'absolute', top: 0, right: 16, marginTop: '15px' }}
                    onClick={() => window.location.href = "/configuracoes"}
                >
                    Configurações
                </Button>
            ) : (
                <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    style={{ position: 'absolute', top: 0, right: 16, marginTop: '15px' }}
                    onClick={() => window.history.back()}
                >
                    <i className="fas fa-chevron-left"></i> Voltar
                </Button>
            )}

            <br />
            <br />
            <Main>{children}</Main>
        </>
    );
}


export default Layout;
